
import BottomSheets from '@/components/BottomSheets.vue';
import { MstCommonCodeVO } from '@/views/biz/order/vo/order.vo';
import { RelUgcReportVO } from "@/views/biz/ugc/vo/ugc.vo";
import axios from "axios";
import { Component, Prop, Vue } from "vue-property-decorator";

@Component({
  components: { BottomSheets }
})
export default class UgcReportForm extends Vue {
  @Prop() ugcTypeCd!: string;
  @Prop() targetCd!: number;
  @Prop() callback!: Function;

  ugcReport: RelUgcReportVO = {} as RelUgcReportVO;
  commonCodes: Array<MstCommonCodeVO> = [] as Array<MstCommonCodeVO>;
  
  // 신고
  reporting() {
    if (!this.ugcReport.reportReasonCd) {
      // 사유를 선택해 주세요.
      alert(this.$t("review.a0001").toString());
      return null;
    } 
    if (this.ugcReport.reportReasonCd =='031005' && !this.ugcReport.text) {
      // 신고 사유를 입력해 주세요.
      alert(this.$t("review.a0004").toString());
      return null;
    }

    if (this.ugcReport.text && this.ugcReport.text.length > 250) {
      //250자 이하로 작성해 주세요.
      alert(this.$t("review.a0002").toString());
      return null;
    }

    // 047001: 리뷰, 047002: 피드, 047003: 사용자
    switch(this.ugcTypeCd) {
      case '047003':
        // 선택한 사용자의 게시물이 목록에서 제외됩니다. 진행하시겠습니까?
        if (confirm(this.$t("feed.c0001").toString()) == false) {
          return null;
        }
        break;
      case '047002':
      case '047001':
      default:
        // 접수하시겠습니까?
        if (confirm(this.$t("review.c0002").toString()) == false) {
          return null;
        }
    }

    axios.post(`/ugc/report`, this.ugcReport).then((r) => {
      BottomSheets.closeAll();
      return this.callback(r, this.targetCd);
    }).catch(e=>{
      BottomSheets.closeAll();
      return this.callback(null, this.targetCd);
    });
  }

  created() {
    this.ugcReport.targetCd = this.targetCd;
    this.ugcReport.ugcTypeCd = this.ugcTypeCd;

    //공통코드(신고구분 '031')
    axios.get(`/common/code/codes/031`).then((r) => {
      this.commonCodes = r.data;
    });
  }

}
